var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.40833V20.925C0 25 3.33333 28.3333 7.40833 28.3333H11.95L11.95 18.725H8.35V14.6333H11.95V11.5083C11.95 7.95834 14.0667 6.00001 17.3 6.00001C18.85 6.00001 20.475 6.27501 20.475 6.27501V9.76667H18.6917C16.9333 9.76667 16.3833 10.8583 16.3833 11.975V14.6333H20.3083L19.6833 18.725H16.375V28.3313L16.3833 28.3333H20.925C25 28.3333 28.3333 25 28.3333 20.9167V7.40833C28.3333 3.33333 25 0 20.9167 0H7.40833C3.33333 0 0 3.33333 0 7.40833Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.08515261133be6522eb51074f1c41a44.svg";
export { ForwardRef as ReactComponent };